<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> {{$t('pages.hourData.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-printer" @click="printlist">{{$t('pages.hourData.print')}}</el-button>
                <el-button type="success" icon="el-icon-takeaway-box" @click="exportlist">{{$t('pages.hourData.export')}}</el-button>
                <span class="toptotalWeight">
                    {{$t('pages.hourData.totalWeight')}}
                    <el-input v-model="totalWeight" class="handle-select" disabled></el-input>
                </span>
            </div>
            <div class="handle-headright">
                <el-date-picker v-model="query.daterange" type="datetimerange" align="right" unlink-panels :range-separator="$t('pages.hourData.rangeSeparator')" :start-placeholder="$t('pages.hourData.startDate')" :end-placeholder="$t('pages.hourData.endDate')" :picker-options="pickerOptions" format="yyyy-MM-dd HH" value-format="yyyy-MM-dd HH" class="handle-select mr10" style="width: 300px">
                </el-date-picker>
                <el-select v-model="query.balanceId" :placeholder="$t('pages.hourData.scale')" class="handle-select mr10">
                    <el-option v-for="item in balanceArr" :key="item.id" :label="isDisplayCompanyName ? item.fullName : item.name" :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.hourData.search')}}</el-button>
            </div>
        </div>

            <el-table :data="logRecords" border class="table" header-cell-class-name="table-header" :height="tableHeight">
                <el-table-column type="index" width="50" :label="$t('pages.hourData.index')"></el-table-column>
                <el-table-column sortable prop="date" :label="$t('pages.hourData.date')">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    {{ scope.row.date | formateData }} {{ scope.row.hour | formatHourRange }}
                </template>
            </el-table-column>
                <el-table-column :prop="isDisplayCompanyName ? 'fullBalanceName' : 'balanceName'" :label="$t('pages.hourData.scaleName')"></el-table-column>
                <el-table-column prop="ferquency" :label="$t('pages.hourData.shift')"></el-table-column>
                <el-table-column :label="$t('pages.hourData.hourWeight')">
                <template slot-scope="scope">
                    <el-button type="text" style="color: #606266; font-size: 15px; padding-top: 0px; padding-bottom: 8px">{{ scope.row.weight }}</el-button>
                </template>
            </el-table-column>
                <el-table-column :label="$t('pages.hourData.cnb')">
                <template slot-scope="scope">
                    <el-button type="text" style="color: #606266; font-size: 15px; padding-top: 0px; padding-bottom: 8px">{{ scope.row.hourCNB }}</el-button>
                </template>
            </el-table-column>
             <!-- <el-table-column label="时间(时)">
                <template slot-scope="scope">
                    <el-button type="text" style="color: #606266; font-size: 15px; padding-top: 0px; padding-bottom: 8px">{{ scope.row.hour }}</el-button>
                </template>
            </el-table-column> -->
           <!-- <el-table-column label="时间范围">
                <template slot-scope="scope">
                    <el-button type="text" style="color: #606266; font-size: 15px; padding-top: 0px; padding-bottom: 8px">{{ scope.row.hour | formatHourRange }}</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
        </div>
    </div>
</div>
</template>

<script>
import {
    dateFormat,
    SortField,
    dateAdd
} from '../../utils/helper';
import print from 'print-js';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'logRecord',
    data: function () {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() == Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                },
                disabledMinutes() {
                    return Array.from({
                        length: 60
                    }, (v, i) => i); // 禁用所有分钟
                },
                disabledSeconds() {
                    return Array.from({
                        length: 60
                    }, (v, i) => i); // 禁用所有秒
                },
                shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            start.setHours(0, 0, 0, 0);
                            end.setHours(23, 0, 0, 0);;
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            start.setHours(0, 0, 0, 0);
                            end.setHours(23, 0, 0, 0);;
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            start.setHours(0, 0, 0, 0);
                            end.setHours(23, 0, 0, 0);;
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            tableHeight: window.innerHeight * 0.70,
            totalWeight: '',
            frequencyArr: [],
            balanceArr: [],
            logRecords: [],
            multipleSelection: [],
            pageCount: 1,
            isDisplayCompanyName: false,
            query: {
                startDate: '',
                endDate: '',
                daterange: '',
                balanceId: 0,
                PageIndex: 1,
                PageSize: 25
            }
        };
    },
    filters: {
        formateData(time) {
            let date = new Date(time);
             //return dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            return dateFormat.formatDate(date, 'yyyy-MM-dd');
        },
        formatHourRange(hour) {
            // 类型检查和边界处理
            let numHour = Number(hour);
            if (isNaN(numHour)) {
                return this.$t('pages.hourData.invalidTime');
            }
            // 确保小时值在0-23范围内
            numHour = Math.floor(numHour) % 24;
            numHour = numHour < 0 ? numHour + 24 : numHour;
            
            // 计算开始时间（小时）
            const startHourStr = numHour.toString().padStart(2, '0');
            const startTime = `${startHourStr}:00:00`;
            // 计算结束时间（小时+1，23点的结束时间为00点）
            const endHour = (numHour + 1) % 24;
            const endHourStr = endHour.toString().padStart(2, '0');
            const endTime = `${endHourStr}:00:00`;
            // 返回时间范围
            return `${startTime}-${endTime}`;
        }
    },
    created() {
        const end = new Date();
        const start = new Date();
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 0, 0, 0);;
        this.query.daterange = [start, end];
        this.getBalance();
    },
    methods: {
        getData() {
            if (this.query.daterange == null) {
                this.$notify.warning(this.$t('pages.hourData.dateRequired'));
                return;
            }
            this.query.startDate = this.formatDateTime(this.query.daterange[0]);
            this.query.endDate = this.formatDateTime(this.query.daterange[1]);
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.query.CreateUserId = userInfo.id;
            this.query.UserName = userInfo.realName;
            this.$zybhttp
                .post('ProdInquiry/HourData', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.logRecords = d;
                        this.totalWeight = res.data.msg;
                        this.pageCount = res.data.data.total || 0;
                        this.isDisplayCompanyName = res.data.info1 == this.$t('pages.hourData.yes') ? true : false;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.hourData.fetchError')));
        },
        getBalance() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.isDisplayCompanyName = res.data.info1 == this.$t('pages.hourData.yes') ? true : false;
                        this.balanceArr = [{
                            id: 0,
                            name: this.$t('pages.hourData.all'),
                            fullName: this.$t('pages.hourData.all'),
                        }].concat(d);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.hourData.fetchError')));
        },
        formatDateTime(dateStr) {
            if (dateStr.length === 13) {
                dateStr += ":00:00";
            }
            return new Date(dateStr);
        },
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy-MM-dd');
        },
        printlist() {
            var newdata = JSON.parse(JSON.stringify(this.logRecords));
            // 进行格式处理的数据
            newdata.forEach((item, index, arr) => {
                item.index = index + 1;
                item.date = this.formateData(item.date); // 日期格式处理
            });
            // 打印方法
            print({
                printable: newdata,
                header: `<div style="display: flex;flex-direction: column;text-align: center">
                        <h3>${this.$t('pages.hourData.printTitle')}</h3>
                    </div>`,
                properties: [{
                        field: 'index',
                        displayName: this.$t('pages.hourData.index'),
                        columnSize: `8%`
                    },
                    {
                        field: 'date',
                        displayName: this.$t('pages.hourData.date'),
                        columnSize: `20%`
                    },
                    {
                        field: this.isDisplayCompanyName ? 'fullBalanceName' : 'balanceName',
                        displayName: this.$t('pages.hourData.scaleName'),
                        columnSize: `20%`
                    },
                    {
                        field: 'ferquency',
                        displayName: this.$t('pages.hourData.shift'),
                        columnSize: `12%`
                    },
                    {
                        field: 'weight',
                        displayName: this.$t('pages.hourData.hourWeight')
                    },
                    {
                        field: 'hourCNB',
                        displayName: this.$t('pages.hourData.cnb')
                    },
                    {
                        field: 'hour',
                        displayName: this.$t('pages.hourData.axisHour'),
                        columnSize: `15%`
                    }
                ],
                type: 'json',
                gridHeaderStyle: 'border: 1px solid #000;text-align:center;padding:6px;0px;',
                gridStyle: 'border: 1px solid #000;text-align:left;padding:5px;10px;text-align: center;'
            });
        },
        exportlist() {
            let date = new Date();
            let name = dateFormat.formatDate(date, 'yyyyMMddhhmm');
            var wb = XLSX.utils.table_to_book(document.querySelector('.table'));
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                FileSaver.saveAs(new Blob([wbout], {
                    type: 'application/octet-stream'
                }), this.$t('pages.hourData.printTitle') + name + '.xlsx');
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout);
            }
            return wbout;
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.toptotalWeight {
    float: right;
    margin-left: 30px;
}

body .el-table th.gutter {
    display: table-cell !important;
}
</style>
